export const tokenL: string               = 'tokenOraculo';
export const refreshL: string             = 'refreshOraculo';
export const userEmailL: string           = 'userEmailOraculo';